import { getTemplate } from '../../../generated/templates';


var templates = {
  string: getTemplate('app/blocks/widgets/forms/types/string.html'),
  password: getTemplate('app/blocks/widgets/forms/types/password.html'),
  string_list: getTemplate('app/blocks/widgets/forms/types/string_list.html'),
  email_multiple: getTemplate('app/blocks/widgets/forms/types/email_multiple.html'),
  email_select: getTemplate('app/blocks/widgets/forms/types/email_select.html'),
  email: getTemplate('app/blocks/widgets/forms/types/email.html'),
  email_list: getTemplate('app/blocks/widgets/forms/types/email_list.html'),
  typeahead: getTemplate('app/blocks/widgets/forms/types/typeahead.html'),
  numeric: getTemplate('app/blocks/widgets/forms/types/numeric.html'),
  boolean: getTemplate('app/blocks/widgets/forms/types/boolean.html'),
  date: getTemplate('app/blocks/widgets/forms/types/date.html'),
  datetime: getTemplate('app/blocks/widgets/forms/types/datetime.html'),
  select: getTemplate('app/blocks/widgets/forms/types/select.html'),
  discrete: getTemplate('app/blocks/widgets/forms/types/discrete.html'),
  discrete_multiple: getTemplate('app/blocks/widgets/forms/types/discrete_multiple.html'),
  text: getTemplate('app/blocks/widgets/forms/types/text.html'),
  text_heading: getTemplate('app/blocks/widgets/forms/types/text_heading.html'),
  text_text: getTemplate('app/blocks/widgets/forms/types/text_text.html'),
  tree: getTemplate('app/blocks/widgets/forms/types/tree.html'),
  likert: getTemplate('app/blocks/widgets/forms/types/likert.html'),
  multi: getTemplate('app/blocks/widgets/forms/types/multi.html'),
  report: getTemplate('app/blocks/widgets/forms/types/report.html'),
  sqlreport: getTemplate('app/blocks/widgets/forms/types/sqlreport.html'),
  goal: getTemplate('app/blocks/widgets/forms/types/goal.html'),
  link: getTemplate('app/blocks/widgets/forms/types/link.html'),
  wysiwyg: getTemplate('app/blocks/widgets/forms/types/wysiwyg.html'),
  signature: getTemplate('app/blocks/widgets/forms/types/signature.html'),
  hidden: getTemplate('app/blocks/widgets/forms/types/hidden.html'),
  deletableItems: getTemplate('app/blocks/widgets/forms/types/deletableItems.html'),
  checkboxes_grid: getTemplate('app/blocks/widgets/forms/types/checkboxes_grid.html'),
  filters: getTemplate('app/blocks/widgets/forms/types/filters.html'),
  username: getTemplate('app/blocks/widgets/forms/types/username.html'),
  json: getTemplate('app/blocks/widgets/forms/types/json.html'),
  file: getTemplate('app/blocks/widgets/forms/types/file.html'),
  search: getTemplate('app/blocks/widgets/forms/types/search.html')
};

var label = getTemplate('app/blocks/widgets/forms/wrappers/label.html');
var toggleButton = getTemplate('app/blocks/widgets/forms/wrappers/toggleButton.html');
var hasError = getTemplate('app/blocks/widgets/forms/wrappers/hasError.html');
var messages = getTemplate('app/blocks/widgets/forms/wrappers/messages.html');
var file = getTemplate('app/blocks/widgets/forms/wrappers/file.html');
var wrappers = {
  label,
  toggleButton,
  hasError,
  messages,
  file
};

(function() {
  'use strict';

  var baseUrl = 'app/blocks/widgets/forms/',
    // eslint-disable-next-line no-unused-vars
      getTemplateUrl = function(name, folder) {
        return baseUrl + folder + '/' + name + '.html';
      },

      buildFieldType = function(name, wrappers) {
        return {
          name: name,
          template: templates[name],
          wrapper: wrappers
        };
      },

      buildWrapper = function(name) {
        return {
          name: name,
          template: wrappers[name]
        };
      },

      allTypes = [
        'string', 'password', 'string_list', 'email_multiple', 'email_select', 'email',
        'email_list', 'typeahead', 'numeric', 'boolean', 'date',
        'datetime', 'select', 'discrete', 'discrete_multiple', 'text', 'text_heading', 'text_text',
        'tree', 'likert', 'multi', 'report', 'sqlreport', 'goal', 'link',
        'wysiwyg', 'signature', 'hidden', 'deletableItems', 'checkboxes_grid', 'filters',
        'username', 'json', 'file', 'search'
      ],
      allWrappers = ['label', 'toggleButton', 'hasError', 'file'],
      commonWrappers = ['hasError'],
      formTypes = [],
      formWrappers = [];

  _.forEach(allTypes, function(type) {
    var wrappers;
    if (type === 'boolean') {
      wrappers = ['toggleButton'];
    } else if (type === 'file') {
      wrappers = ['file', ...commonWrappers];
    } else if (
      type.indexOf('text_') === 0 ||
      type.indexOf('link') > -1 ||
      type.indexOf('hidden') > -1
    ) {
      wrappers = [];
    } else {
      wrappers = _.union(['label'], commonWrappers);
    }

    formTypes.push(buildFieldType(type, wrappers));
  });

  _.forEach(allWrappers, function(wrapper) {
    formWrappers.push(buildWrapper(wrapper));
  });

  var dateTimeFormat = {
    inputdate: 'd/M/yyyy',
    dateonly: 'd MMM, yyyy',
    datetime: 'd MMM, yyyy H:mm:ss',
    timeonly: 'H:mm:ss'
  };

  var emptySignature = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAjgAAADcCAQAAADXNhPAAAAC' +
    'IklEQVR42u3UIQEAAAzDsM+/6UsYG0okFDQHMBIJAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDA' +
    'cwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHADDAQwHMBwAwwEMB8BwAMMBDAfAcADDATAcwHAAwwEw' +
    'HMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEwHMBwAMMBMBzAcAAMBzAcwHAADAcwHADDAQwHMBwAwwEMB8' +
    'BwAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcCQADAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDATAcwHAADAcw' +
    'HMBwAAwHMBwAwwEMBzAcAMMBDAfAcADDAQwHwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEMB8' +
    'BwAMMBMBzAcADDATAcwHAADAcwHMBwAAwHMBwAwwEMB8BwAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcAAMBzAc' +
    'AMMBDAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDkQAwHMBwAAwHMBwAwwEMBzAcAMMBDAfAcADDAQwHwHAAwwEwHM' +
    'BwAMMBMBzAcAAMBzAcwHAADAcwHADDAQwHMBwAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHMBwAAwHMBwAwwEMBzAc' +
    'AMMBDAegeayZAN3dLgwnAAAAAElFTkSuQmCC';

  angular.module('widgets.forms')
    .constant('ALL_TYPES', allTypes)
    .constant('FORM_TYPES', formTypes)
    .constant('FORM_WRAPPERS', formWrappers)
    .constant('DATETIME_FORMAT', dateTimeFormat)
    .constant('EMPTY_SIGNATURE', emptySignature);
})();
